/* eslint-disable */

export const onUpdateSumBySourceExportResults = /* GraphQL */ `
  subscription OnUpdateSumBySourceExportResults(
    $filter: ModelSubscriptionSumBySourceExportResultsFilterInput
  ) {
    onUpdateSumBySourceExportResults(filter: $filter) {
      id
      status
      s3_key
      signed_s3_url
      errors
      saved_dt
    }
  }
`;

export const onUpdateSumBySourceDisplayCache = /* GraphQL */ `
  subscription OnUpdateSumBySourceDisplayCache(
    $filter: ModelSubscriptionSumBySourceDisplayCacheFilterInput
  ) {
    onUpdateSumBySourceDisplayCache(filter: $filter) {
      client_id
      status
      display_data
      errors
      createdAt
      updatedAt
    }
  }
`;
